var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, computed, observable, makeObservable } from 'mobx';
import { MenubarPathStepNeighbourTopic } from '../Neighbour/MenubarPathStepNeighbourTopic';
import { MenubarPathStepNeighbourPath } from '../Neighbour/MenubarPathStepNeighbourPath';
import { runtime } from '../../../../classes/runtime/Runtime';
export class MenubarPathStep {
    parent;
    depth;
    depthName;
    isNeighbourMenuOpen = false;
    isStepButtonHovering = false;
    isCreateTopicOpen = false;
    isCreatePathOpen = false;
    constructor({ parent, depth, depthName }) {
        makeObservable(this);
        this.parent = parent;
        this.depth = depth;
        this.depthName = depthName;
    }
    get menubarPath() {
        return this.parent;
    }
    get app() {
        return this.menubarPath.app;
    }
    get location() {
        return this.menubarPath.menubarLocation && this.menubarPath.menubarLocation.locationSteps[this.depthName];
    }
    get path() {
        return this.location;
    }
    get previousStep() {
        if (this.depth <= 0)
            return undefined;
        return this.parent.steps[this.depth - 1];
    }
    get nextStep() {
        if (this.depth >= this.parent.steps.length)
            return undefined;
        return this.parent.steps[this.depth];
    }
    get shouldStepPreloadData() {
        if (runtime.isServerRuntime)
            return true;
        return this.isNeighbourMenuOpen || this.isStepButtonHovering;
    }
    get stepName() {
        if (this.depth === 2)
            return 'Schulart';
        if (this.depth === 3)
            return 'Klassenstufe';
        if (this.depth === 4)
            return 'Fach';
        if (this.depth === 5)
            return 'Bereich';
        // if (this.depth === 6) return 'Thema';
        return '';
    }
    get label() {
        if (this.location)
            return this.location.name || '';
        if (this.app.location && this.menubarPath.menubarLocation) {
            // faster from own pathURI
            if (this.depth < this.menubarPath.menubarLocation.locationSteps.pathnamepieces.length) {
                return this.menubarPath.menubarLocation.locationSteps.pathnamepieces[this.depth];
            }
        }
        return 'Auswahl';
    }
    get neighbourData() {
        if (this.previousStep && this.previousStep.path) {
            return this.previousStep.path.pathChildren.pathChildrenQuery.streamedRef;
        }
        if (this.previousStep && this.previousStep.path) {
            return this.previousStep.path.pathChildren.pathChildrenQuery.streamedRef;
        }
        return [];
    }
    get neighbours() {
        if (!this.neighbourData)
            return [];
        return this.neighbourData.map(locationData => {
            if (locationData.type === 'path') {
                return new MenubarPathStepNeighbourPath({ locationData, parent: this });
            }
            return new MenubarPathStepNeighbourTopic({ locationData, parent: this });
        });
    }
    get solidNeighbourLocations() {
        return this.neighbours.map(neighbour => neighbour.location).filter(l => l);
    }
    handleStepButtonClick() {
        const x = runtime.streamedPackages.Lazy;
        if (this.isNeighbourMenuOpen) {
            this.isNeighbourMenuOpen = false;
        }
        else {
            this.parent.closeAllSteps();
            this.isNeighbourMenuOpen = true;
            this.solidNeighbourLocations.forEach(location => location.locationProgress.progressQuery.refetch());
            this.solidNeighbourLocations.forEach(location => location.locationGrade.gradeQuery.refetch());
        }
    }
}
__decorate([
    observable
], MenubarPathStep.prototype, "isNeighbourMenuOpen", void 0);
__decorate([
    observable
], MenubarPathStep.prototype, "isStepButtonHovering", void 0);
__decorate([
    observable
], MenubarPathStep.prototype, "isCreateTopicOpen", void 0);
__decorate([
    observable
], MenubarPathStep.prototype, "isCreatePathOpen", void 0);
__decorate([
    computed
], MenubarPathStep.prototype, "label", null);
__decorate([
    computed
], MenubarPathStep.prototype, "neighbours", null);
__decorate([
    action.bound
], MenubarPathStep.prototype, "handleStepButtonClick", null);
